import type { ReactNode } from "react";

export default function SectionTitle({
  eyebrow,
  title,
  text,
  align = "center",
  tone = "dark",
}: {
  eyebrow?: string;
  title: ReactNode;
  text?: string;
  align?: "center" | "left";
  tone?: "dark" | "light";
}) {
  const isLight = tone === "light";
  return (
    <div className={align === "center" ? "text-center" : "text-left"}>
      {eyebrow ? (
        <p
          className={`mb-3 text-xs font-semibold uppercase tracking-[0.22em] ${
            isLight ? "text-sky-pale" : "text-sky"
          }`}
        >
          {eyebrow}
        </p>
      ) : null}
      <h2
        className={`text-3xl leading-tight font-semibold sm:text-4xl ${
          isLight ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {text ? (
        <p
          className={`mt-4 text-base leading-relaxed sm:text-lg ${
            align === "center" ? "mx-auto max-w-3xl" : "max-w-3xl"
          } ${isLight ? "text-white/80" : "text-ink/75"}`}
        >
          {text}
        </p>
      ) : null}
    </div>
  );
}
